import { useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import MakeGetRequest from "../utils/MakeGetRequest";
import makePutRequest from "../utils/makePutRequest";
import SmallTitleText from "../SmallTitleText";
import FormInputField from "../FormInputField";

const EditOrganizerForm = () => {
  const [postLoading, setPostLoading] = useState(false);
  const [postSuccessMsg, setPostSuccessMsg] = useState("");
  const [postError, setPostError] = useState("");

  const formRef = useRef(null);

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const slug = searchParams.get("slug");

  const {
    data: formData,
    loading: formLoading,
    error: formError,
  } = MakeGetRequest({
    route: `editorganizer?slug=${slug || ""}`,
    forceToken: true,
    errorCodeRedirect: 404,
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setPostSuccessMsg("");
    setPostError("");

    if (!slug) {
      setPostError("Slug saknas för arrangören");
      return;
    }

    if (!formRef.current.checkValidity()) {
      formRef.current.reportValidity();
      return;
    }

    const formElements = formRef.current.elements;
    const name = (formData?.current_organizer?.name || "").trim();
    const organizerSlug = (formData?.current_organizer?.slug || "").trim();
    let description = "";
    let officialMail = "";
    let officialHomepage = "";
    let imageMain = "";

    for (let i = 0; i < formElements.length; i++) {
      const element = formElements[i];

      if (element.name === "description") {
        description = element.value.trim();
      }
      if (element.name === "official_mail") {
        officialMail = element.value.trim();
      }
      if (element.name === "official_homepage") {
        officialHomepage = element.value.trim();
      }
      if (element.name === "image_main") {
        imageMain = element.value.trim();
      }
    }

    const payload = {
      name,
      slug: organizerSlug,
      description,
      official_mail: officialMail,
      official_homepage: officialHomepage,
      image_main: imageMain,
    };

    setPostLoading(true);

    try {
      const { error } = await makePutRequest(
        `update_organizer?slug=${slug}`,
        payload,
      );

      if (error) {
        throw new Error(error);
      }

      setPostSuccessMsg("Arrangören är uppdaterad");
    } catch (error) {
      setPostError(error.message || "Ett fel uppstod");
    } finally {
      setPostLoading(false);
    }
  };

  if (!slug) {
    return <p>Ingen arrangör vald att redigera.</p>;
  }

  if (formLoading) {
    return <p>Laddar arrangör...</p>;
  }

  if (formError) {
    return <p className="text-error">Fel: {formError}</p>;
  }

  if (!formData?.current_organizer) {
    return <p>Ingen arrangördata hittades.</p>;
  }

  return (
    <div className="p-4">
      <form ref={formRef} onSubmit={handleSubmit} noValidate>
        <SmallTitleText text="Uppdatera arrangör" />

        <FormInputField
          type="text"
          name="name"
          label="Namn"
          defaultValue={formData.current_organizer.name || ""}
          placeholder="Arrangörens namn"
          disabled={true}
          required={true}
          altLabel="Låst: kan inte ändras"
        />

        <FormInputField
          type="text"
          name="slug"
          label="Slug"
          defaultValue={formData.current_organizer.slug || ""}
          placeholder="arrangor-slug"
          disabled={true}
          required={true}
          altLabel="Låst: kan inte ändras"
        />

        <FormInputField
          type="textarea"
          name="description"
          label="Beskrivning"
          defaultValue={formData.current_organizer.description || ""}
          altLabel="Kort beskrivning av arrangören"
        />

        <FormInputField
          type="email"
          name="official_mail"
          label="Officiell mail"
          defaultValue={formData.current_organizer.official_mail || ""}
          placeholder="kontakt@dinsida.se"
        />

        <FormInputField
          type="url"
          name="official_homepage"
          label="Officiell hemsida"
          defaultValue={formData.current_organizer.official_homepage || ""}
          placeholder="https://..."
        />

        <FormInputField
          type="url"
          name="image_main"
          label="Huvudbild (URL)"
          defaultValue={formData.current_organizer.image_main || ""}
          placeholder="https://..."
          altLabel="Lämna tom om du inte vill visa någon huvudbild"
        />

        {postSuccessMsg && (
          <p className="font-semibold text-success mb-3">{postSuccessMsg}</p>
        )}
        {postError && (
          <p className="font-semibold text-error mb-3">{postError}</p>
        )}

        <div className="flex gap-4 items-center">
          <button
            className="btn btn-primary"
            type="submit"
            disabled={postLoading}
          >
            {postLoading ? "Uppdaterar..." : "Uppdatera"}
          </button>

          <a href="/userprofile" className="btn btn-outline">
            Tillbaka till profil
          </a>
        </div>
      </form>
    </div>
  );
};

export default EditOrganizerForm;
